export default "__VITE_ASSET__CJD1RvYf__"